<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xymWZ0/tc-custom/9780253002822.jpg?1726755912789" alt="This image is the cover for the book Battle of Surigao Strait, Twentieth-Century Battles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Battle of Surigao Strait, Twentieth-Century Battles
      </h1>
      <p class="bookDescription body article font2">
        <b>“[Tully] paints Admiral Nishimura's high-speed run into history with an entirely fresh palette of detail.” —James D. Hornfischer, <i>New York Times</i>–bestselling </b><b>author of <i>Neptune’s Inferno</i></b><br/>  <br/> Surigao Strait in the Philippine Islands was the scene of a major battleship duel during the Battle of Leyte Gulf. Because the battle was fought at night and had few survivors on the Japanese side, the events of that naval engagement have been passed down in garbled accounts.<br/>  <br/> Anthony P. Tully pulls together all of the existing documentary material, including newly discovered accounts and a careful analysis of US Navy action reports, to create a new and more detailed description of the action. In several respects, Tully's narrative differs radically from the received versions and represents an important historical corrective. Also included in the book are a number of previously unpublished photographs and charts that bring a fresh perspective to the battle.<br/>  <br/> “By giving a fuller view of the Japanese side, Tully's work forces a substantial revision of the traditional picture of the battle. <i>Battle of Surigao Strait</i> is not only military history based on scrupulous use of a plethora of new source materials, but is a spanking good read. Highly recommended.” —<i>War in History</i><br/>  <br/> “Tully has managed to trace the complicated flow of and reason for events on the nights of 24-25 October with a skill and aplomb that forces one to reconsider previously held views.” —<i>Naval History</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anthony P. Tully
      </h2>
      
      <p class="authorDescription body article">Anthony P. Tully is an independent scholar and historian of the Imperial Japanese Navy. He is author (with Jon Parshall) of Shattered Sword, a study of the Battle of Midway. He lives in Dallas, Texas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?33a566dc